import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Panel } from "./Panel";

export const PilotPanel = ({ admin, d, onChange }) => {
  const [size, setSize] = useState(250);
  const prep = async () => {
    try { const r = await api.post("/email-marketing/launch/pilot", { size: Number(size), name: "Pilot campaign" }); toast.success(`Pilot draft prepared for ${r.data.recipients} recipients (not sent)`); onChange(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Could not prepare pilot"); }
  };
  const ready = d.blockers.filter((b) => !b.startsWith("Only ")).length === 0 && d.subscribers.verified_eligible >= 200;
  return (
    <Panel testid="launch-pilot" title="6. Controlled pilot (200–300 recipients)"
      sub="Prepared as a draft from the most recent verified eligible customers only. It is never sent without your explicit approval, and live sending remains locked.">
      {d.pilot ? <p className="text-xs" data-testid="pilot-existing">Draft prepared for {d.pilot.recipient_plan} recipients · <Link className="underline" to={`/email-marketing/campaigns/${d.pilot.id}`}>open draft</Link></p>
        : <p className="text-xs text-slate-500" data-testid="pilot-none">{ready ? "Ready to prepare." : `Available once there are at least 200 verified eligible subscribers and the checks pass (now ${d.subscribers.verified_eligible}).`}</p>}
      {admin && !d.pilot && <div className="flex gap-2 items-center"><Input type="number" min={200} max={300} value={size} onChange={(e) => setSize(e.target.value)} className="w-24 h-9" data-testid="pilot-size" />
        <Button size="sm" disabled={!ready} onClick={prep} data-testid="pilot-prepare-btn">Prepare pilot draft</Button></div>}
    </Panel>
  );
};
